import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Users (Facilitators)", -1)
const _hoisted_2 = { class: "p-button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Export as CSV ")
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Invite Facilitator ")
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("No records found.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_download = _resolveDirective("download")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_DataTable, {
      value: _ctx.users,
      dataKey: "id"
    }, {
      header: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_2, _hoisted_4)), [
          [_directive_download, '/reports/users']
        ]),
        _createVNode(_component_router_link, {
          class: "p-button",
          to: { name: _ctx.UserInviteRoute }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      empty: _withCtx(() => [
        _hoisted_8
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "displayName",
          header: "User"
        }),
        _createVNode(_component_Column, {
          field: "email",
          header: "Email"
        }),
        _createVNode(_component_Column, {
          field: "organization",
          header: "Organization"
        }),
        _createVNode(_component_Column, {
          field: "dateRegistered",
          header: "Date Registered"
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(new Date(slotProps.data.dateRegistered).toLocaleDateString()), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "license.title",
          header: "License"
        }),
        _createVNode(_component_Column, {
          header: "Actions",
          class: "actions-column"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "p-button",
                to: _ctx.editRoute(slotProps.data.id)
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}